'use strict';

module.exports = {
  exporting: {
    enabled: false
  }
};